import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteClient, getAllClients, searchClientData } from '../../Redux/Actions/DashOptions'
import Loader from '../../Common/Loader'
import { faEdit, faMagnifyingGlass, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import AlertDialogSlide from '../../Common/DeleteDialog'
import { toast } from 'react-toastify'
import { debounce } from 'lodash'
import { Circles } from 'react-loader-spinner'
import Pagination from '../../Common/Pagination'
import { capitalizeFirstLetter } from '../../Utils/helper'

const ClientList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const [deleteId, setDeleteID] = useState()
    const [searchValue, setSearchValue] = useState('')

    const clientData = useSelector((state) => state?.DashOptionsSlice?.allClients?.data) // client list data 
    const clientListLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // ckecking client list loading
    const { current_page, last_page, from, to, total } = useSelector((state) => state?.DashOptionsSlice?.allClients || {}); // getting pagination


    const afterSearchedData = useSelector((state) => state?.DashOptionsSlice?.clientSearchedData?.data) // getting serched data
    const searchedDataLoading = useSelector((state) => state?.DashOptionsSlice?.isLoading) // checking searched data laoding
    const searchPaginationData = useSelector((state) => state?.DashOptionsSlice?.clientSearchedData || {}); // getting pagination


    const [page, setPage] = useState(current_page || 1);

    const handleEdit = (seletedItem) => {
        navigate(`/dashboard/addclient/${seletedItem?.id}`, { state: { editClientData: seletedItem } })
    }

    const handleDelete = (selectedID) => {
        setDeleteID(selectedID)
        setOpen(true)
    }

    const handleDeleteByModal = () => {
        dispatch(deleteClient(deleteId)).then((res) => {
            if (res?.payload) {
                toast.success(res?.payload?.message)
                setOpen(false);
                dispatch(getAllClients())
            } else {
                toast.error('An error occured')
            }
        })
    }

    const debouncedSearch = useMemo(() => debounce((query) => {
        if (query.trim() === "") {
            dispatch(searchClientData({ field: "", value: "" }));
            dispatch(getAllClients({page:page}));
            setPage(current_page || 1);
        } else {
            setPage(searchPaginationData?.current_page || 1)
            dispatch(searchClientData({ field: 'name', value: query }));
        }
    }, 500), [dispatch]);


    const handleSearch = useCallback((e) => {
        const value = e.target.value;
        setSearchValue(value);
        debouncedSearch(value);
    }, [debouncedSearch]);

    const isSearching = useMemo(() => searchValue.trim() !== "", [searchValue]);
    const showSearchedData = isSearching;

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        dispatch(getAllClients({page:page}))
    }, [])
    return (
        <div className="p-6 bg-gray-50 min-h-screen">
            {!isSearching && clientListLoading && <Loader />}
            <h2 className="text-lg font-semibold text-gray-800">Client Details</h2>
            <div className="flex sm:flex-row items-start sm:items-center justify-end mb-4">
                {/* Search Field */}
                <div className="relative w-full sm:w-64">
                    <input
                        type="text"
                        placeholder="Search by Name"
                        onChange={(e) => handleSearch(e)}
                        className="w-full bg-gray-100 border border-gray-700 rounded-lg px-4 py-2 pl-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                    <div className="absolute inset-y-0 left-1 flex items-center pointer-events-none">
                        <FontAwesomeIcon icon={faMagnifyingGlass} className="text-gray-400" />
                    </div>
                </div>

            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-blue-600 text-white">
                        <tr>
                            <th className="py-2 px-6 text-left">Name</th>
                            <th className="py-2 px-6 text-left">Email</th>
                            <th className="py-2 px-6 text-left">Phone</th>
                            <th className="py-2 px-6 text-left">Provider</th>
                            <th className="py-2 px-6 text-left">Type</th>
                            <th className="py-2 px-6 text-left">Status</th>
                            <th className="py-2 px-6 text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {searchedDataLoading && isSearching ? (
                            <tr>
                                <td colSpan="12" className="text-center py-6 text-gray-900">
                                    <div className="flex justify-center items-center h-40">
                                        <Circles
                                            height="80"
                                            width="80"
                                            color="#2563EB"
                                            ariaLabel="circles-loading"
                                            visible={true}
                                        />
                                    </div>
                                </td>
                            </tr>) : showSearchedData ? (

                                afterSearchedData && afterSearchedData?.length > 0 ? (
                                    afterSearchedData.map((client, index) => (
                                        <tr
                                            key={index}
                                            className="border-b hover:bg-gray-100 transition duration-200"
                                        >
                                            <td className="py-3 px-6">{capitalizeFirstLetter(client?.name) || '--'}</td>
                                            <td className="py-3 px-6">{client?.email || '--'}</td>
                                            <td className="py-3 px-6">{client?.phone || '--'}</td>
                                            <td className="py-3 px-6">{client?.provider?.name || '--'}</td>
                                            <td className="py-3 px-6">{client?.type?.name || '--'}</td>
                                            <td className="py-3 px-6">
                                                <span
                                                    className={`px-2 py-1 rounded-full text-sm font-medium ${client.status === 'active'
                                                        ? 'bg-green-100 text-green-800'
                                                        : 'bg-red-100 text-red-800'
                                                        }`}
                                                >
                                                    {client.status || '--'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex items-center justify-center gap-2 ">
                                                <button className="text-blue-600 hover:text-blue-900" onClick={() => handleEdit(client)}><FontAwesomeIcon icon={faEdit} className="text-blue-600" /></button>
                                                <button className="text-red-600 hover:text-blue-900" onClick={() => handleDelete(client?.id)}><FontAwesomeIcon icon={faTrash} className="text-red-600" /></button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="12" className="py-6 text-center text-gray-900">
                                            No search results found.
                                        </td>
                                    </tr>
                                )
                            ) : (
                            clientData && clientData?.length > 0 ? (
                                clientData.map((client, index) => (
                                    <tr
                                        key={index}
                                        className="border-b hover:bg-gray-100 transition duration-200"
                                    >
                                        <td className="py-3 px-6">{capitalizeFirstLetter(client?.name) || '--'}</td>
                                        <td className="py-3 px-6">{client?.email || '--'}</td>
                                        <td className="py-3 px-6">{client?.phone || '--'}</td>
                                        <td className="py-3 px-6">{client?.provider?.name || '--'}</td>
                                        <td className="py-3 px-6">{client?.type?.name || '--'}</td>
                                        <td className="py-3 px-6">
                                            <span
                                                className={`px-2 py-1 rounded-full text-sm font-medium ${client.status === 'active'
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-red-100 text-red-800'
                                                    }`}
                                            >
                                                {client?.status || '--'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium flex items-center justify-center gap-2 ">
                                            <button className="text-blue-600 hover:text-blue-900" onClick={() => handleEdit(client)}><FontAwesomeIcon icon={faEdit} className="text-blue-600" /></button>
                                            <button className="text-red-600 hover:text-blue-900" onClick={() => handleDelete(client?.id)}><FontAwesomeIcon icon={faTrash} className="text-red-600" /></button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" className="py-6 text-center text-gray-900">
                                        No client data available.
                                    </td>
                                </tr>
                            )
                        )}
                        <tr></tr>

                    </tbody>
                </table>
                <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                    <p className="text-sm text-gray-700">
                        Showing <span className="font-medium">{showSearchedData ? searchPaginationData?.from : from}</span> to <span className="font-medium">{showSearchedData ? searchPaginationData?.to : to}</span> of <span className="font-medium">{showSearchedData ? searchPaginationData?.total : total}</span> results
                    </p>
                    <Pagination
                        count={!showSearchedData ? last_page : searchPaginationData?.last_page}
                        page={page}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
            <AlertDialogSlide open={open} setOpen={setOpen} handleDeleteByModal={handleDeleteByModal} />

        </div>
    )
}

export default ClientList
